import { h, Component } from "preact";
import { connect } from "react-redux";
import editIcon from "../../assets/images/icon-edit.svg";
import leftIcon from "../../assets/images/icon-arrow-left.svg";
import rightIcon from "../../assets/images/icon-arrow-right.svg";
import colors from "./Colors";
import { openModal } from "../../state/actions/attendeeProfileActions";
import { css } from "emotion";
import { scrollToNextX } from "../../utils/ScrollTo";

const summaryStyles = css({
  "@media (max-width: 600px)": {
    display: "flex",
    width: "100%",
    overflowX: "hidden"
  }
});

const profileStyles = css({
  paddingBottom: 24,
  "@media (max-width: 600px)": {
    minWidth: "100%"
  }
});

const ticketTypeStyle = css({
  display: "flex",
  alignItems: "center",
  "@media (max-width: 600px)": {
    minWidth: "50%"
  }
});

const ticketTypeListStyle = css({
  "@media (max-width: 600px)": {
    display: "flex",
    flexWrap: "wrap",
    paddingLeft: 12,
    paddingRight: 12
  }
});

const attendeeTitleStyle = css({
  marginTop: 24,
  paddingBottom: 11,
  borderBottom: "solid 1px #dedede",
  "@media (max-width: 600px)": {
    borderBottom: "none"
  }
});

const pageIncrementorStyle = css({
  display: "none",
  "@media (max-width: 600px)": {
    display: "flex",
    padding: "0px 2px"
  }
});

const noAttendeeStyle = css({
  width: "100%",
  textAlign: "center",
  marginTop: 32,
  paddingBottom: 32,
  "@media (max-width: 600px)": {
    marginTop: 0,
    paddingBottom: 0
  }
});

const summaryId = "attendee-profile-summary";

class TicketAssignSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attendeeIndex: 0
    };
  }

  pageChange = num => {
    scrollToNextX(num, summaryId);
    this.setState({ attendeeIndex: num });
  };

  render({ attendeeProfile, order, ticketsGroupedByType, openModal }) {
    const { attendeeIndex } = this.state;
    const { profiles } = attendeeProfile;
    const attendeeProfileLength = profiles.length;
    const ticketLookup = ticketsGroupedByType
      .map((ticketTypeGroup, i) => {
        return ticketTypeGroup.tickets.map(ticket => {
          ticket.color = colors[i];
          return ticket;
        });
      })
      .reduce((arr, tickets) => {
        return arr.concat(tickets);
      }, [])
      .reduce((map, ticket) => {
        const { attendeeProfileId } = ticket;
        if (attendeeProfileId) {
          if (!map[attendeeProfileId]) {
            map[attendeeProfileId] = [];
          }
          map[attendeeProfileId].push(ticket);
        }
        return map;
      }, {});
    const profilesExist =
      profiles.filter(profile => {
        const { _id } = profile;
        const assignedTickets = ticketLookup[_id] || [];
        if (assignedTickets.length === 0) {
          return false;
        }
        return true;
      }).length > 0;
    if (!profilesExist) {
      return (
        <div>
          <div className={attendeeTitleStyle}>
            <h2 style={{ marginLeft: 16, marginBottom: 0 }}>Attendees</h2>
          </div>
          <div id={summaryId} className={summaryStyles}>
            <p className={noAttendeeStyle}>
              You haven’t assigned any tickets yet
            </p>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className={attendeeTitleStyle}>
          <h2 style={{ marginLeft: 16, marginBottom: 0 }}>Attendees</h2>
        </div>
        <div id={summaryId} className={summaryStyles}>
          {profiles.map(profile => {
            const { firstName, lastName, email, _id } = profile;
            const assignedTickets = ticketLookup[_id] || [];
            if (assignedTickets.length === 0) {
              return null;
            }
            return (
              <div className={profileStyles}>
                <div
                  style={{
                    backgroundColor: "#f9f9fa",
                    display: "flex",
                    paddingTop: 10,
                    paddingBottom: 10,
                    alignItems: "center",
                    marginBottom: 12
                  }}
                >
                  <h4
                    style={{ marginLeft: 16, marginBottom: 0, flexGrow: 1 }}
                  >{`${firstName} ${lastName}`}</h4>
                  <div
                    onClick={() => openModal(profile, false, true)}
                    style={{
                      width: 24,
                      height: 24,
                      background: `url(${editIcon})`,
                      marginRight: 16,
                      cursor: "pointer"
                    }}
                  />
                </div>
                <div className={ticketTypeListStyle}>
                  {assignedTickets.map(({ ticketTypeName, color }) => {
                    return (
                      <div className={ticketTypeStyle}>
                        <div
                          style={{
                            height: 32,
                            width: 6,
                            backgroundColor: color,
                            marginRight: 10
                          }}
                        />
                        <div
                          data-cy={`${firstName}-${lastName}-${ticketTypeName}`}
                          style={{ flexGrow: 1, fontSize: 14 }}
                        >
                          {ticketTypeName}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div className={pageIncrementorStyle}>
          <button
            disabled={attendeeIndex === 0}
            onClick={() => this.pageChange(attendeeIndex - 1)}
            style={{
              width: 24,
              height: 24,
              background: `url(${leftIcon})`,
              marginRight: 32,
              cursor: "pointer",
              backgroundRepeat: "no-repeat",
              flexGrow: 1,
              backgroundPosition: "right"
            }}
          />
          <div style={{ fontSize: 12, color: "#5a626c" }}>
            {`${attendeeIndex + 1} of ${attendeeProfileLength}`}
          </div>
          <button
            disabled={attendeeIndex === attendeeProfileLength - 1}
            onClick={() => this.pageChange(attendeeIndex + 1)}
            style={{
              width: 24,
              height: 24,
              background: `url(${rightIcon})`,
              marginLeft: 32,
              cursor: "pointer",
              backgroundRepeat: "no-repeat",
              flexGrow: 1
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    return {
      attendeeProfile: state.attendeeProfile,
      order: state.order
    };
  },
  {
    openModal
  }
)(TicketAssignSummary);



// WEBPACK FOOTER //
// ./routes/conferences/AssignSummary.js